export const Resize = ({ obj, children }) => (
  <span style={{ fontSize: obj.data.get('fontSize') }}>{children}</span>
);
